import { EscrowStatusEnum } from 'src/graphql/schema';
import { IconBadgeCertified, IconBadgeValidated, IconBadgeVerified } from 'src/components/Svg/Images';
import { getActiveCertification } from 'src/utils/escrow';
import { cn } from 'src/lib/utils';

import { useEscrowDashboardCard } from '../model/context';

const CertificateBadges = () => {
  const { viewModel } = useEscrowDashboardCard();
  const { status, activatedAt, certificationVerified, certificationCertified } = viewModel;

  const activeCertification = getActiveCertification({
    activatedAt,
    certificationVerified,
    certificationCertified,
  });

  if (!activeCertification) return null;

  return (
    <div className={cn('flex items-center gap-1', status === EscrowStatusEnum.Terminated && 'opacity-70')}>
      <IconBadgeValidated className={cn('size-5 opacity-30', activatedAt && 'size-6 opacity-100')} />
      <IconBadgeVerified className={cn('size-5 opacity-30', certificationVerified && 'size-6 opacity-100')} />
      <IconBadgeCertified className={cn('size-5 opacity-30', certificationCertified && 'size-6 opacity-100')} />
    </div>
  );
};

export { CertificateBadges };
